import React, { useState } from 'react'

import { ThemeProvider, createTheme } from '@mui/material'
// import GoogleFontLoader from 'react-google-font-loader';
import { amber } from '@mui/material/colors'

import ThemeContext from './ThemeContext'

const initialTheme = {
  palette: {
    type: 'light',
    primary: {
      light: '#fa7982',
      main: '#F95863',
      dark: '#af545b',
      mainGradient: 'linear-gradient(90deg,#FF416C 0%,#FF4B2B 100%)'
    },
    secondary: {
      light: amber[200],
      main: amber[400],
      dark: amber[600]
    }
  },
  spacing: 8,
  shape: {
    borderRadius: 4
  },
  typography: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 750,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }
}
const ThemeEngine  = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(initialTheme)

  const changeTheme = (value) => setCurrentTheme(value)
  const resetTheme  = () => setCurrentTheme(initialTheme)

  return (
    <ThemeContext.Provider value={{ changeTheme, resetTheme }}>
      <ThemeProvider theme={createTheme(currentTheme)}>
        {/* <GoogleFontLoader
          fonts={[
            {
              font: currentTheme.typography.fontFamily,
              weights: [100, 300, 400, 500, 700, 900],
            },
          ]}
        /> */}
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}
export default ThemeEngine
